import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

/**
 * Fetch Progress Component
 * Shows step-by-step progress during article fetching and extraction
 * Only renders the white card content - header is handled by Main.js
 */
const FetchProgress = ({ progress = {} }) => {
  const [showExtendedMessage, setShowExtendedMessage] = useState(false);

  // Show reassurance message after 60 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowExtendedMessage(true);
    }, 60000);

    return () => clearTimeout(timer);
  }, []);
  const fetchSteps = [
    { id: 'checking', name: 'Verifying domain' },
    { id: 'fetching', name: 'Fetching article from website' },
    { id: 'extracting', name: 'Extracting article content with AI' }
  ];

  const getStepStatus = (stepId) => {
    const stepProgress = progress[stepId];
    if (!stepProgress) return 'pending';
    return stepProgress.status;
  };

  const renderStepIcon = (status, index) => {
    if (status === 'completed') {
      return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      );
    }
    if (status === 'in_progress') {
      return <Spinner animation="border" size="sm" style={{ width: '12px', height: '12px' }} />;
    }
    return index + 1;
  };

  const getStepStyle = (status) => {
    if (status === 'completed') {
      return { background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: '#fff' };
    }
    if (status === 'in_progress') {
      return { background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', color: '#fff' };
    }
    return { backgroundColor: '#e2e8f0', color: '#94a3b8' };
  };

  return (
    <Row className="justify-content-center">
      <Col lg={6} md={8}>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
        }}>
          {fetchSteps.map((step, index) => {
            const status = getStepStatus(step.id);
            return (
              <div
                key={step.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '1rem 0',
                  borderBottom: index < fetchSteps.length - 1 ? '1px solid #f1f5f9' : 'none'
                }}
              >
                <div
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '1rem',
                    fontSize: '13px',
                    fontWeight: '600',
                    flexShrink: 0,
                    ...getStepStyle(status)
                  }}
                >
                  {renderStepIcon(status, index)}
                </div>
                <span style={{
                  color: status === 'pending' ? '#94a3b8' : '#1a1a2e',
                  fontWeight: status === 'in_progress' ? '600' : '500',
                  fontSize: '0.95rem'
                }}>
                  {step.name}
                </span>
              </div>
            );
          })}

          <p style={{ color: '#94a3b8', marginTop: '1.5rem', marginBottom: 0, fontSize: '0.875rem', textAlign: 'center' }}>
            {showExtendedMessage
              ? "Still working on it — larger articles may take a bit longer. Thanks for your patience!"
              : "This may take 30-60 seconds..."}
          </p>
        </div>
      </Col>
    </Row>
  );
};

export default FetchProgress;
